// extracted by mini-css-extract-plugin
export default {"allProductList":"AllProductList_allProductList__E6sTG"};